import {
  Box,
  Text,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
} from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { Form, Formik, FormikProps } from 'formik';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { TextInputFormField } from 'packages/common-frontend/components/FormField';

export const EditIntermediateFieldModal = ({
  isOpen,
  onCancel,
  onSave,
  intermediateField,
  idx,
}: {
  isOpen: boolean;
  onCancel: Function;
  onSave: Function;
  intermediateField: CreditAgreement.Config.Liabilities.Inputs.IntermediateField;
  idx: number;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onCancel();
      }}
      size="3xl"
    >
      <ModalOverlay />
      <ModalContent padding="20px" maxWidth="min-content" minWidth="3xl">
        <ModalHeader>Edit Intermediate Field</ModalHeader>
        <ModalCloseButton />
        <ModalBody width="100%">
          <Formik
            initialValues={{
              field: intermediateField.field,
              config: {
                formula: intermediateField.config.formula,
                engineVersion: intermediateField.config.engineVersion,
                type: intermediateField.config.type,
              },
            }}
            onSubmit={(props) => {
              onSave(props, idx);
            }}
          >
            {(formProps: FormikProps<any>) => (
              <Form onSubmit={formProps.handleSubmit}>
                <Box mb="5">
                  <TextInputFormField label="Field Name" name="field" />
                </Box>

                <Box mb="5">
                  <Text fontWeight="semibold">Formula</Text>
                  <Text mb="3" fontSize="sm" fontStyle="italic">
                    Exclude initial &quot;=&quot;, as this defaults to formula
                  </Text>
                  <Editor
                    value={formProps.values.config.formula}
                    onChange={(val) =>
                      formProps.setFieldValue('config.formula', val)
                    }
                    theme="vs-dark"
                    width="100%"
                    height="300px"
                    options={{
                      fixedOverflowWidgets: true,
                      minimap: { enabled: false },
                    }}
                  />
                </Box>

                <Flex justifyContent="flex-end">
                  <Button type="submit" w="24" mr="3">
                    Done
                  </Button>
                  <Button w="24" onClick={() => onCancel()}>
                    Cancel
                  </Button>
                </Flex>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
